import { Div } from "../../../base/components/native/div"
import * as styles from "./process-status.style"

export const ProcessStatus = () => {
    const base = Div()
    base.style(styles.baseStyle)

    return base
}